export const MENU_ITEM_TEST_ID = 'menu-item';

export const MENU_ITEM_GRID_AVATAR = 'avatar';
export const MENU_ITEM_GRID_NAME = 'name';
export const MENU_ITEM_GRID_ACCOUNT = 'account';
export const MENU_ITEM_GRID_STATUS = 'status';
